import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';
import ReactPixel from 'react-facebook-pixel';

export default function Pricing() {
  const [activeTab, setActiveTab] = useState("subscription");

  // Track Pricing page view
  useEffect(() => {
    ReactPixel.track('ViewContent', { content_name: 'Pricing Page' });
  }, []);

  return (
    <section className="pricing-wrapper">
      <h1>Our Packages</h1>

      {/* ─── Toggle Tabs ─────────────────────────────── */}
      <div className="pricing-tabs">
        <button
          className={activeTab === "subscription" ? "tab active" : "tab"}
          onClick={() => setActiveTab("subscription")}
        >
          Subscriptions
        </button>
        <button
          className={activeTab === "onetime" ? "tab active" : "tab"}
          onClick={() => setActiveTab("onetime")}
        >
          One-Time Projects
        </button>
      </div>

      {/* ─── SUBSCRIPTION PRICING ────────────────────── */}
      {activeTab === "subscription" && (
        <div className="pricing-tiers">
          {/* Starter */}
          <div className="pricing-card">
            <h2>Starter</h2>
            <p className="price">$895<span>/mo</span></p>
            <p className="card-description">For individuals and small projects getting started.</p>
            <ul>
              <li>Up to 4 videos edited monthly</li>
              <li>Standard editing package</li>
            </ul>
            <Link 
              to="/interest" 
              state={{ subscription: "Subscription" }}  // 👈 Passes subscription type
              className="btn-secondary"
            >
              Work With Us
            </Link>
          </div>

          {/* Growth */}
          <div className="pricing-card featured">
            <h2>Growth</h2>
            <p className="price">$2,195<span>/mo</span></p>
            <p className="card-description">For growing businesses that need more power and support.</p>
            <ul>
              <li>Up to 6 videos edited monthly</li>
              <li>Advanced editing package</li>
            </ul>
            <Link 
              to="/interest" 
              state={{ subscription: "Subscription" }}
              className="btn-secondary"
            >
              Work With Us
            </Link>
          </div>

          {/* Pro */}
          <div className="pricing-card">
            <h2>Pro</h2>
            <p className="price">$3,995<span>/mo</span></p>
            <p className="card-description">For agencies and teams requiring premium features.</p>
            <Link to="/contact" className="btn-secondary">Contact Us</Link>
          </div>
        </div>
      )}

      {/* ─── ONE-TIME PROJECT PRICING ────────────────── */}
      {activeTab === "onetime" && (
        <div className="pricing-tiers">
          {/* Standard Video */}
          <div className="pricing-card">
            <h2>Standard Video</h2>
            <p className="price">From $250</p>
            <p className="card-description">Perfect for social clips, reels, or YouTube videos.</p>
            <ul>
              <li>1 standard video edited</li>
              <li>Standard editing package</li>
            </ul>
            <Link 
              to="/interest" 
              state={{ subscription: "One-Time" }}  // 👈 Passes one-time type
              className="btn-secondary"
            >
              Work With Us
            </Link>
          </div>

          {/* Advanced Video */}
          <div className="pricing-card featured">
            <h2>Advanced Video</h2>
            <p className="price">From $550</p>
            <p className="card-description">For projects needing motion graphics & enhanced visuals.</p>
            <ul>
              <li>1 advanced video edited</li>
              <li>Advanced editing package</li>
            </ul>
            <Link 
              to="/interest" 
              state={{ subscription: "One-Time" }}
              className="btn-secondary"
            >
              Work With Us
            </Link>
          </div>

          {/* Custom */}
          <div className="pricing-card">
            <h2>Custom Project</h2>
            <p className="price">Contact Us</p>
            <p className="card-description">Tailored to unique needs and larger projects.</p>
            <ul>
              <li>Custom deliverables</li>
              <li>Flexible scope & features</li>
            </ul>
            <Link to="/contact" className="btn-secondary">Contact Us</Link>
          </div>
        </div>
      )}

      {/* Keep Feature Comparison + FAQ + Footer unchanged */}
    </section>
  );
}
